import { Reveal, ScrollHint } from "@/components/Reveal";
import { STEPS } from "@/data/content";

const Percorso = () => (
  <section id="percorso" data-testid="percorso-section" className="bg-sage py-24 sm:py-36">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="max-w-2xl" data-testid="percorso-heading">
        <Reveal>
          <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] text-ivory/60">
            <span className="font-serif text-2xl italic text-terracotta">06</span>
            <span className="h-px w-10 bg-ivory/30" />
            Come entrare in struttura
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-ivory leading-[1.08]">
            Il percorso di accoglienza
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 text-base leading-relaxed text-ivory/75">
            Cinque passi semplici e guidati, perché ogni famiglia si senta accompagnata fin dal primo contatto.
          </p>
        </Reveal>
        <ScrollHint testid="percorso-scroll-hint" light />
      </div>

      <div className="mt-10 flex touch-pan-x snap-x snap-mandatory gap-4 overflow-x-auto pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden lg:mt-16 lg:touch-auto lg:grid lg:grid-cols-5 lg:gap-6 lg:overflow-visible lg:pb-0">
        {STEPS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.12} className="w-[72%] shrink-0 snap-start lg:w-auto">
            <div className="h-full rounded-[2rem] border border-ivory/15 bg-ivory/10 p-6 backdrop-blur-sm lg:p-7" data-testid={`step-${i + 1}`}>
              <span className="font-serif text-5xl italic text-terracotta/90">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="mt-4 font-serif text-xl font-medium text-ivory">{s.title}</h3>
              <p className="mt-2.5 text-[13px] leading-relaxed text-ivory/70">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Percorso;
